module.exports = __webpack_public_path__ + "static/img/section_culture.e179f90.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/section_culture.png
// module id = IrT2
// module chunks = 0